import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { loginSelectors, nucleusConstants, currentUserSelectors } from '@lifesize/nucleus';
import { Global } from 'state/Global';
import { LSError } from '../../interfaces/LSError';
import { logger } from '../logger';
import { selectPermissionsObject } from '../../selectors/permissionsSelector';
import { get } from 'lodash';
import { login } from 'actions/initClientActions';

const mapStateToProps = (state: Global, ownProps: {}) => {
  const loginState = loginSelectors.loginSelector(state);
  const reload = get(state, 'nucleus.login.reload', false);
  const { isLoggedIn, isLoggingIn, isReconnecting, registeredLogin} = loginState;
  const currentUser = currentUserSelectors.myInfo(state);
  const permissionsObject = selectPermissionsObject(state);

  return {
    isLoggedIn, isLoggingIn, isReconnecting, registeredLogin, currentUser, permissionsObject, reload
  };
};

const mapDispatchToProps = (dispatch: Function): object => ({
  registeredLogin: async () => {
    await dispatch(login());
  }
});

interface AuthProps {
  isLoggedIn: boolean;
  isLoggingIn: boolean;
  isReconnecting: boolean;
  reload: boolean;
  registeredLogin: () => void;
}

const withAuthBase = (BaseComponent: React.ComponentType<{}>) => {

  return class extends React.Component<AuthProps> {

    componentDidMount() {
      if (!this.props.isLoggedIn && !this.props.isReconnecting && !this.props.isLoggingIn) {
        this.handleLogin();
      }
    }

    componentDidUpdate(nextProps: AuthProps) {
      if (nextProps.reload) {
        window.location.reload();
      }
    }

    handleError = (error: LSError) => {
      if (error && error.reason === nucleusConstants.ACCESS_DENIED) {
        logger.warn('ACCESS_DENIED');
      }
    }

    handleLogin = async () => {
      try {
        await this.props.registeredLogin();
      } catch (error) {
        this.handleError(error);
      }
    }

    render() {
      return <BaseComponent {...this.props} />;
    }
  };
};

export const withAuth = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withAuthBase
);
